// --- Core ---
import * as Sentry from "@sentry/react";
// --- SaniQ ---
import {clearSecrets} from "helpers/reducers/Secret";
import {API} from "api";

function logout() {
  return function (dispatch) {
    return API.signOut()
      .finally(() => {
        Sentry.setUser(null);
        dispatch(clearSecrets());
      });
  };
}

export {
  logout
};
